// extracted by mini-css-extract-plugin
export default {"modalInfo":"Admin_modalInfo__D5cH2","centered":"Admin_centered__UHE7G","forum":"Admin_forum__b0oGB"};